import React, { useState } from 'react';
import { md, isBlankBlock } from '../utils/markdown';

const ITNewsSection = () => {
  const [selectedTopic, setSelectedTopic] = useState('');
  const [results, setResults] = useState('');

  const IT_NEWS_API_URL = 'https://rif9noyuig.execute-api.ap-northeast-2.amazonaws.com/news/genai-news-api';

  // 람다는 BLOCKCHAIN 도 그대로 받는다. 화면에서만 뺐으므로 되살리려면 이 줄만 다시 넣으면 된다.
  const topics = [
    { id: 'AI', name: 'AI' },
    { id: 'ROBOT', name: 'ROBOT' },
    { id: 'QUANTUM', name: 'QUANTUM' },
    { id: 'METAVERSE', name: 'METAVERSE' }
  ];

  const handleTopicClick = async (topic) => {
    setSelectedTopic(topic);
    setResults(`${topic} 관련 최신 뉴스를 AI가 요약 중입니다...`);

    try {
      const response = await fetch(IT_NEWS_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic: topic })
      });

      if (response.ok) {
        const data = await response.json();

        // 결과 영역에 white-space: pre-wrap 이 걸려 있다. 문자열 안의 줄바꿈과 들여쓰기가
        // 그대로 화면의 빈 줄과 공백이 되므로, 태그 사이에 군더더기 공백을 두지 않는다.
        const paragraphs = data.summary.split('\n\n')
          .filter(p => !isBlankBlock(p))
          .map(p => `<div class="analysis-paragraph">${md(p.trim())}</div>`)
          .join('');
        const summaryHtml =
          `<h3>'${topic}' 최신 뉴스 요약</h3><div class="analysis-content">${paragraphs}</div>`;

        // 결과 영역에 white-space: pre-wrap 이 걸려 있어 문자열 안의 줄바꿈과 들여쓰기가
        // 그대로 화면의 공백이 된다. 목록은 한 줄로 이어 붙여 군더더기 공백을 만들지 않는다.
        let articlesHtml = '';
        if (data.news && data.news.length > 0) {
          const items = data.news.map(article =>
            `<li><a href="${article.link}" target="_blank" rel="noopener noreferrer">${article.title}</a></li>`
          ).join('');
          articlesHtml = `<h4 class="article-heading">요약에 사용된 기사</h4>` +
            `<ul class="article-list">${items}</ul>`;
        }

        setResults(summaryHtml + articlesHtml);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
    }
  };

  return (
    <section className="service-section">
      <h2>IT News 요약 AI 서비스</h2>
      <p className="info-text">(Google News 최신 기사 기준)</p>
      <div className="button-container one-line">
        {topics.map(topic => (
          <button
            key={topic.id}
            className={`category-btn ${selectedTopic === topic.id ? 'selected' : ''}`}
            onClick={() => handleTopicClick(topic.id)}
          >
            {topic.name}
          </button>
        ))}
      </div>
      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default ITNewsSection;